import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=0f565e23&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports